import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { AuthGuard } from './core/providers/guards/auth.guard';
import { AuthenticationService } from './core/providers/services/authentication.service';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { SignOutComponent } from './pages/sign-out/sign-out.component';
import { CoreModule } from './core/core.module';
import { CategoriesModule } from './pages/categories/categories.module';
import { NavComponent } from './core/nav/nav.component';
import { TabBarComponent } from './core/tab-bar/tab-bar.component';
import { ProductTypesModule } from './pages/product-types/product-types.module';
import { AssetAvailabilityModule } from './pages/asset-availability/asset-availability.module';
import { HttpLanguageLoader, SettingsService } from './core/providers';
import { EquipmentAssetModule } from './pages/equipment-asset/equipment-asset.module';
import { AssetUnavailabilityModule } from './pages/asset-unavailability/asset-unavailability.module';
import { SettingsModule } from './pages/settings/settings.module';

import { RestrictedComponent } from './pages/restricted/restricted.component';
import { MaintenanceModeModule } from './maintenance-mode/maintenance-mode.module';
import { ClientBrandingModule } from 'src/app/client-branding/client-branding.module';
import { FiltersModule } from 'src/app/filters/filters.module';
import { CompetitiveDisclaimerDialogComponent } from './core/disclaimers/competitive-disclaimer-dialog.component';
import { DisclaimersModule } from './core/disclaimers/disclaimers.module';

@NgModule({
  declarations: [
    AppComponent,
    CallbackComponent,
    SignOutComponent,
    NavComponent,
    TabBarComponent,
    RestrictedComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    CategoriesModule,
    ProductTypesModule,
    AssetAvailabilityModule,
    EquipmentAssetModule,
    AssetUnavailabilityModule,
    SettingsModule,
    InfiniteScrollModule,
    FiltersModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: HttpLanguageLoader,
        deps: [HttpClient, AuthenticationService],
      },
    }),
    MaintenanceModeModule,
    ClientBrandingModule,
    CompetitiveDisclaimerDialogComponent,
    DisclaimersModule,
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    SettingsService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
